import { render, staticRenderFns } from "./CiFullscreenSidebar.vue?vue&type=template&id=f4924a2a&"
import script from "./CiFullscreenSidebar.vue?vue&type=script&lang=js&"
export * from "./CiFullscreenSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CiFullscreenSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports